export const TASK_STATUS_LABELS = {
    pending: 'Pendiente',
    in_progress: 'En progreso',
    completed: 'Completada',
};

/** Estados que el profesor puede asignar manualmente a la tarea. */
export const TEACHER_TASK_STATUS_LABELS = {
    pending: 'Pendiente',
    in_progress: 'En revisión',
};

/** La entrega del alumno es lo que cuenta como "completada"; no se muestra en UI del profesor. */
export const shouldShowTeacherTaskStatusBadge = (status) => (
    status === 'in_progress'
);

/** Solo se puede editar antes de la fecha de activación. */
export const canTeacherEditTask = (task) => task?.windowState === 'upcoming';

export const TASK_PRIORITY_LABELS = {
    low: 'Baja',
    medium: 'Media',
    high: 'Alta',
};

export const TASK_WINDOW_LABELS = {
    upcoming: 'Pendiente de activación',
    active: 'Activa',
    expired: 'Vencida',
};

/** Para el profesor la fecha límite no “vence” la tarea: sigue abierta para revisar. */
export const teacherWindowLabel = (windowState) => {
    if (windowState === 'expired') return TASK_WINDOW_LABELS.active;
    return TASK_WINDOW_LABELS[windowState] || TASK_WINDOW_LABELS.active;
};

export const teacherWindowBadgeClass = (windowState) => (
    windowBadgeClass(windowState === 'expired' ? 'active' : windowState)
);

const BADGE_BASE = 'inline-flex items-center px-2 py-0.5 rounded-md text-[11px] font-semibold';

export const priorityBadgeClass = (priority) => {
    const map = {
        low: 'bg-green-100 text-green-700',
        medium: 'bg-orange-100 text-orange-700',
        high: 'bg-red-100 text-red-700',
    };
    return `${BADGE_BASE} ${map[priority] || map.medium}`;
};

export const windowBadgeClass = (windowState) => {
    const map = {
        upcoming: 'bg-sky-100 text-sky-700',
        active: 'bg-green-100 text-green-700',
        expired: 'bg-gray-200 text-gray-600',
    };
    return `${BADGE_BASE} ${map[windowState] || map.active}`;
};

export const statusBadgeClass = (status) => {
    const map = {
        pending: 'bg-gray-100 text-gray-600',
        in_progress: 'bg-indigo-100 text-indigo-700',
        completed: 'bg-green-100 text-green-700',
    };
    return `${BADGE_BASE} ${map[status] || map.pending}`;
};

/** Opciones de hora cada 30 minutos + 23:59 para fechas límite de fin de día. */
export const TIME_OPTIONS = (() => {
    const options = [];
    for (let h = 0; h < 24; h += 1) {
        for (const m of [0, 30]) {
            const value = `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
            options.push({ value, label: value });
        }
    }
    options.push({ value: '23:59', label: '23:59' });
    return options;
})();

/** Combina una fecha (Date del datepicker) con una hora 'HH:MM' en un Date local. */
export const combineDateTime = (date, time) => {
    if (!date) return null;
    const [hours, minutes] = String(time || '00:00').split(':').map(Number);
    const combined = new Date(date);
    combined.setHours(hours || 0, minutes || 0, 0, 0);
    return combined;
};

/** Extrae 'HH:MM' de una fecha para poblar el select de hora al editar. */
export const extractTime = (value) => {
    if (!value) return '';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return '';
    return `${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`;
};

export const courseDisplayName = (course) => {
    if (!course) return '';
    const parts = [course.language?.name, course.level?.name].filter(Boolean);
    return parts.length ? parts.join(' · ') : (course.identifier || '');
};

export const teacherDisplayName = (teacher) => (
    [teacher?.firstName, teacher?.lastName].filter(Boolean).join(' ')
);
